<template>
    <div class="page_body">
        <div class="data_main">

            <div class="data_group mt18">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="openAdd">添加</el-button>
                <el-button type="primary" size="small" @click="triggerFileUpload">导入水卡</el-button>
                <el-button type="primary" size="small" @click="getTemplate">导出模板</el-button>
                <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none;">
            </div>

            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column prop="cardNo" label="水卡编号" min-width="180px" align="center"></el-table-column>
                    <el-table-column prop="spec" label="水卡" min-width="180px" align="center"></el-table-column>
                    <el-table-column prop="price" label="价格" min-width="180px" align="center"></el-table-column>
                    <el-table-column label="使用期限" min-width="180px" align="center">
                      <template slot-scope="scope">
                        <span>{{scope.row.beginDate}}</span> ~ <span>{{scope.row.endDate}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="deliveryArea" label="所属区域" min-width="180px" align="center">
                      <!-- <template slot-scope="scope">
                        <span>{{ scope.row.deliveryArea.join[','] }}</span>
                      </template> -->
                    </el-table-column>
                    <el-table-column prop="state" label="状态" min-width="180px">
                      <template slot-scope="scope">
                        <span v-if="scope.row.state == 0">未绑定</span>
                        <span v-if="scope.row.state == 1">待配送</span>
                        <span v-if="scope.row.state == 2">配送中</span>
                        <span v-if="scope.row.state == 3">已收货</span>
                        <span v-if="scope.row.state == 4">已完成</span>
                        <span v-if="scope.row.state == 5">理赔中</span>
                        <span v-if="scope.row.state == 6">理赔驳回</span>
                        <span v-if="scope.row.state == 7">理赔完成</span>
                        <span v-if="scope.row.state == 10">已使用</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="100">
                      <template slot-scope="scope">
                        <el-button type="text" @click="delData(scope.row.id)">删除</el-button>
                      </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog class="popup_dialog" title="新增水卡" :visible.sync="addCard" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <el-form ref="formData" :model="formData" :rules="rules" label-width="80px" size="small">
                  <el-form-item label="卡号：" prop="cardNo">
                      <el-input v-model="formData.cardNo" placeholder="请输入卡号"></el-input>
                  </el-form-item>
                  <el-form-item label="密码：" prop="password">
                      <el-input v-model="formData.password" placeholder="请输入密码"></el-input>
                  </el-form-item>
                  <el-form-item label="使用期限：" prop="dateData2">
                    <el-date-picker
                            style="width: 100%"
                            v-model="formData.dateData2"
                            type="daterange"
                            range-separator="~"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="使用区域：" prop="deliveryArea">
                    <el-select v-model="formData.deliveryArea" multiple placeholder="请选择">
                      <el-option
                        v-for="item in proList"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                      </el-option>
                    </el-select>
                    <!-- <div style="display:flex">
                      <el-input v-model="formData.area" placeholder="请输入使用区域" :validate-event="false"></el-input>
                      <el-button type="text" @click="pushArea">添加</el-button>
                    </div> -->
                  </el-form-item>
                  <!-- <el-form-item label="水卡范围：" v-if="formData.deliveryArea.length>0">
                    <div style="width:100%;display:flex" v-for="(item,index) in formData.deliveryArea" :key="index">
                      <div style="width:50%;text-align:center">{{item}}</div>
                      <el-button type="text" @click="delAreas(ndex)">删除</el-button>
                    </div>
                  </el-form-item> -->
                  <el-form-item label="水卡价格：" prop="price">
                      <el-input v-model="formData.price" placeholder="请输入水卡价格"></el-input>
                  </el-form-item>
                  <el-form-item label="所属类型：" prop="cardId">
                    <el-select v-model="formData.cardId">
                        <el-option v-for="(item,index) in option" :key="index" :label="item.spec" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
  
                  <el-form-item>
                      <el-button type="primary" :loading="isSubmitLoading" @click="submitFormAdd('formData')">提  交</el-button>
                      <el-button @click="closeAdd">关  闭</el-button>
                  </el-form-item>
              </el-form>
            </el-dialog>
            <pagination v-if='isShow' :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import pagination from '@/components/pagination'
import {mapState} from "vuex";
import {getCardList,postOrder,getTemplate,getOrderAdd,postTemplate,delOrder,getPro} from '@/api'
export default {
  name: "contentArticleIndex",
  data () {
    return {
      addCard:false,
      allowedFileTypes: ['xls','xlsx'],
      rules:{
        cardNo: [
          {required: true, message: '请输入卡号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        deliveryArea: [
          {required: true, message: '请添加使用区域', trigger: 'blur'}
        ],
        price: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ],
        dateData2:[
          {required: true, message: '请选择使用期限', trigger: 'change'}
        ],
        cardId:[
          {required: true, message: '请选择所属类型', trigger: 'change'}
        ],
      },
      formData:{
        cardNo:'',
        password:'',
        area:'',
        deliveryArea:[],
        beginDate:'',
        endDate:'',
        price:'',
        cardId:'',
        dateData2:[]
      },
      option:[],
      isShow:false,
      isSubmitLoading:false,
      isSearchLoading: false,
      isRequestLoading: false,
      listData: [],
      proList:[]
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  created () {
    this.getOrderAdd()
    this.getCardList()
    this.getPro()
  },
  methods: {
    getPro(){
      getPro().then(res=>{
        this.proList = res.data
      })
    },
    openAdd(){
      this.formData.password = this.generateRandomPassword(10)
      this.addCard=true
    },
    generateRandomPassword(length) {
      const charset = "ABCDEFGHLJKMNPQRSTUVWXYZ0123456789";
      let password = "";
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        password += charset[randomIndex];
      }
      return password;
    },
    pushArea(){
      if (!this.formData.area) {
        return this.$message.error('输入区域禁止为空')
      }
      if (this.formData.deliveryArea.indexOf(this.formData.area)<0) {
        this.formData.deliveryArea.push(this.formData.area)
        this.formData.area = ''
      } else {
        this.$message.error('输入区域重复')
      }
    },
    delAreas(key){
      this.formData.deliveryArea.splice(key,1)
    },
    delData(id){
      this.$confirm('此操作将永久删除该水卡, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delOrder(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '水卡删除成功',
              type: 'success',
              showClose: true,
            });
            this.getOrderAdd()
          }
        })
      }).catch(() => {});
    },
    triggerFileUpload(){
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0]

      // 验证文件类型
      const fileType = file.name.split(".").pop().toLowerCase();
      console.log(event)
      console.log(file)
      if (!this.allowedFileTypes.includes(fileType)) {
        this.$message.error("错误: 不支持的文件类型。");
        return
      }

      // 验证文件大小
      // if (file.size > this.maxFileSize) {
      //   this.$message.error(`错误: 文件大小超过 ${this.maxFileSize / (1024 * 1024)}MB 限制。`);
      //   return
      // }

      const formData = new FormData()
      formData.append('file', file)

      // 测试用,项目中换成自己的上传接口
      
      axios({
        method: "POST",
        baseURL: window.config.baseURL,
        url: postTemplate(),
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json',
          'card': localStorage.getItem('access_token'),
        },
        data: formData,
      })
        .then(response => {
          if (response.data.code == 0){
            this.$message.success("文件上传成功。");
          } else {
            this.$message.error(response.data.message)
          }
            this.$refs.fileInput.value=''

          console.log('文件上传成功:', response.data)
        })
        .catch(error => {
            this.$refs.fileInput.value=''
          // this.$message.error("文件上传失败。");

          console.error('文件上传失败:', error)
        })
    },
    // postTemplate(){},
    getTemplate(){
      getTemplate().then()
    },
    getOrderAdd(){
      getOrderAdd().then(res=>{
        this.listData = res.data.records
      })
    },
    getCardList(){
      getCardList().then(res=>{
        this.option = res.data
      })
    },
    submitFormAdd (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.formData.area) {
            return this.$message.error('请先添加完使用区域')
          }
          this.isSubmitLoading = true
          console.log(this.formData)
          this.formData.beginDate = this.formData.dateData2[0]
          this.formData.endDate = this.formData.dateData2[1]
          // let arr = [this.formData.deliveryArea]
          postOrder({
            data: this.formData
          }).then(res => {
            this.isSubmitLoading = false
            if (res.code === 0) {
              this.$message({
                message: '水卡新增成功',
                type: 'success',
                showClose: true,
              });
              this.formData= {
                cardNo:'',
                password:'',
                area:'',
                deliveryArea:[],
                beginDate:'',
                endDate:'',
                price:'',
                cardId:'',
                dateData2:[]
              },
              this.addCard = false
              this.getOrderAdd()
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
    },
    closeAdd(){
      this.formData= {
        cardNo:'',
        password:'',
        area:'',
        deliveryArea:[],
        beginDate:'',
        endDate:'',
        price:'',
        cardId:'',
        dateData2:[]
      },
      this.addCard = false
    },
  },
  components: {
    pagination
  }
}
</script>
